module.exports = __webpack_public_path__ + "img/valance-trojan.81a6475a.svg";